import Phaser from 'phaser';
import {gsap} from 'gsap';


export default class Telop{

    constructor(){
        GAME_REF.obj.telop = this;

        this.scene = GAME_REF.scene;
        this.manager = GAME_REF.obj.manager;

        this.container = null;
        this.bg = null;
        this.startText = null;
        this.endText = null;

        this.startTimer = null;
        this.endTimer = null;
        this._pause = this._pause.bind(this);
        this._resume = this._resume.bind(this);

        this._init();
    }


    gameStart(){
        GAME_REF.obj.sound.playOne('na_start');

        this.scene.tweens.add({
            targets: this.bg,
            alpha: 0.9,
            scaleX: 1,
            duration: 300,
            ease: 'Cubic.easeOut'
        });

        this.scene.tweens.add({
            targets: this.startText,
            alpha: 1,
            x: 0,
            duration: 700,
            delay: 400,
            ease: 'Cubic.easeOut'
        });
        
        this.startTimer = gsap.delayedCall(2, ()=>{
            this.manager.start();
            this.startTimer = null;
        });

        window.addEventListener(PLAYBACK.EVENT.PAGE_PAUSE, this._pause);
        window.addEventListener(PLAYBACK.EVENT.PAGE_RESUME, this._resume);
    }


    hide(){

        this.scene.tweens.add({
            targets: this.container,
            alpha: 0,
            duration: 500,
            ease: 'Cubic.easeOut'
        });
    }


    gameEnd(){
        this.bg.alpha = 0;
        this.bg.scaleX = 0.5;
        this.scene.tweens.add({
            targets: this.bg,
            alpha: 0.9,
            scaleX: 1,
            duration: 300,
            ease: 'Cubic.easeOut'
        });

        this.scene.tweens.add({
            targets: this.endText,
            alpha: 1,
            x: 0,
            duration: 700,
            delay: 200,
            ease: 'Cubic.easeOut'
        });

        this.startText.alpha = 0;
        this.container.alpha = 1;

        GAME_REF.obj.sound.playOne('na_timeup');

        this.endTimer = gsap.delayedCall(2.5, ()=>{
            window.removeEventListener(PLAYBACK.EVENT.PAGE_PAUSE, this._pause);
            window.removeEventListener(PLAYBACK.EVENT.PAGE_RESUME, this._resume);
            this.endTimer = null;
            this.scene.nextScene();
        });
    }


    _init(){
        this._create();
    }


    _create(){
        this.container = this.scene.add.container(0, 288);
        this.container.setDepth(100);

        this.bg = this.scene.add.graphics();
        this.bg.fillStyle(0x111C3A);
        this.bg.fillRect(0, 0, 1280, 198);
        this.bg.alpha = 0;
        this.bg.scaleX = 0.5,
        this.container.add(this.bg);

        this.startText = this.scene.add.image(-40, 0, 'telop_start');
        this.startText.setOrigin(0, 0);
        this.startText.alpha = 0;
        this.container.add(this.startText);

        this.endText = this.scene.add.image(-40, 0, 'telop_timeup');
        this.endText.setOrigin(0, 0);
        this.endText.alpha = 0;
        this.container.add(this.endText);
    }


    _pause(){
        if(this.startTimer) this.startTimer.pause();
        if(this.endTimer) this.endTimer.pause();
    }

    _resume(){
        if(this.startTimer) this.startTimer.resume();
        if(this.endTimer) this.endTimer.resume();
    }
}